import { useMutation } from '@apollo/client';

import {
  BulkUpdateContractLineShipToCustomer,
  BulkUpdateContractLineShipToCustomerVariables
} from '@/graphql/contracts/_generated_/bulkUpdateContractLineShipToCustomer.mutation';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import GetBCContractLinesQuery from '@/graphql/contracts/getPaginatedFilteredBCContractLines.query.gql';
import GetPaginatedFilteredVariableContractLinesQuery from
  '@/graphql/contracts/getPaginatedFilteredVariableContractLines.query.gql';
import BulkUpdateContractLineShipToCustomerMutation
  from '@/graphql/contracts/bulkUpdateContractLineShipToCustomer.mutation.gql';
import { notificationService } from '@/services/notification/notification.client';
import {
  ALL_ITEMS
} from '@/config/common.config';

const getContractLineRefetchQuery = (contractId: UUID, isVariable: boolean) => {

  if (isVariable) {
    return {
      query: GetPaginatedFilteredVariableContractLinesQuery,
      variables: {
        filter: { headerPrimaryKey: { eq: contractId } },
        first: ALL_ITEMS
      }
    };
  }

  return {
    query: GetBCContractLinesQuery,
    variables:
    {
      filter: {
        contractId: { eq: contractId }
      },
      first: ALL_ITEMS
    }
  };
};


export function useBulkUpdateContractLineShipToCustomer(contractId: UUID) {
  const [_bulkUpdateContractLineShipToCustomer, { loading }] =
    useMutation<BulkUpdateContractLineShipToCustomer, BulkUpdateContractLineShipToCustomerVariables>(
      BulkUpdateContractLineShipToCustomerMutation,
      {
        client: apolloClientContracts,
        onError: (err) => notificationService.open({
          title: 'Error',
          text: err.message,
          type: 'danger'
        }),
        awaitRefetchQueries: true,
      },
    );

  const bulkUpdateContractLineShipToCustomer = async (params: BulkUpdateContractLineShipToCustomerVariables,
    isVariable: boolean, shouldRefetchCls: boolean) => {

    const refetchQueries = shouldRefetchCls ? [
      getContractLineRefetchQuery(contractId, isVariable)
    ] : [];

    const result = await _bulkUpdateContractLineShipToCustomer({
      variables: {
        ...params,
      },
      awaitRefetchQueries: true,
      refetchQueries: refetchQueries
    });

    return result?.data?.bulkUpdateContractLineShipToCustomer;
  };

  return {
    bulkUpdateContractLineShipToCustomer,
    bulkUpdateContractLineShipToCustomerLoading: loading
  };
}
